import React, { useEffect } from "react";

const VerticalAd = (props) => {
    const { adnumber, adslot, adsize } = props;
    useEffect(() => {
        window.googletag = window.googletag || { cmd: [] };
        window.googletag.cmd.push(function () {
            window.googletag.defineSlot("'" + adslot + "'", adsize, 'v-ad' + adnumber)
                .addService(window.googletag.pubads());
            window.googletag.enableServices();
        });
        return () => {
            window.googletag = null;
        };
    }, []);

    useEffect(() => {
        if (window.googletag) {
            window.googletag.cmd.push(function () {
                window.googletag.display('v-ad' + adnumber);
            });
        }
    }, []);

    return (
        <>
            <div style={{ width: '10%', top: '15%', left: '15px', zIndex: '0', position: 'fixed', backgroundColor: 'white' }}>
                <div id={`v-ad${adnumber}`}></div>
            </div>
        </>
    )
}

export default VerticalAd;
